<div
  [ngClass]="{ 'cookie-bar-visible': !acceptedCookies() }"
  class="scroll-to-top"
>
  <button
    (click)="scrollToTop()"
    [ngClass]="{ visible: showButton }"
    class="scroll-to-top__button"
    type="button"
  >
    <div class="scroll-to-top__inner">
      <svg class="icon-arrow-up" height="14" width="14">
        <use xlink:href="images/icons/svg-sprite.svg#arrow-up"></use>
      </svg>
    </div>
  </button>
</div>
